module.exports = __webpack_public_path__ + "img/airline_seat_recline_normal.f2332cd0.svg";